import FilterModel from 'app/components/FilterModel';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { reportOverALlDataHeader } from 'app/constants/table-header-constants';
import useOverAllDataReport from './useOverAllDataReport';

const OverAllDataReport = () => {
  const {
    pageLoading,
    filteredData,
    navigate,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    resetfilterModel,
    handleSubmit,
    handleFilterCancel,
    fetchReportData,
    isFiltering,
  } = useOverAllDataReport();

  return (
    <>
      <div className='cms-content__container'>
        <div className='cms-content__container billmanagement'>
          <PaginatedTable
            fulldata={filteredData}
            sectionObj={sectionObj}
            columns={reportOverALlDataHeader}
            data={filteredData}
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            pageCountNumber={pageCount}
            totalNumber={totalNumber}
            pageLoading={pageLoading}
            navigate={navigate}
            isLoading={pageLoading}
            fetchData={fetchReportData}
            isFiltering={isFiltering}
            values={values}
          />
        </div>
        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilterModel}
          >
            <>
              <div className='offcanvas-item'>
                <label>Mall Name:</label>
                <input
                  type='text'
                  value={values?.mallName}
                  onChange={(e) =>
                    setValues({ ...values, mallName: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>Membership Type:</label>
                <input
                  type='text'
                  value={values?.membershipType}
                  onChange={(e) =>
                    setValues({ ...values, membershipType: e.target.value })
                  }
                />
              </div>
              <label> Date of bill ranges:</label>
              <div className='offcanvas-item'>
                <label> Start Date</label>
                <input
                  type='date'
                  value={values?.invoice_dateStart}
                  max={values?.invoice_dateEnd}
                  onChange={(e) =>
                    setValues({ ...values, invoice_dateStart: e.target.value })
                  }
                />
              </div>

              <div className='offcanvas-item'>
                <label>End Date</label>
                <input
                  type='date'
                  value={values?.invoice_dateEnd}
                  min={values?.invoice_dateStart}
                  onChange={(e) =>
                    setValues({ ...values, invoice_dateEnd: e.target.value })
                  }
                />
              </div>
              <label>First Bill Date ranges:</label>
              <div className='offcanvas-item'>
                <label>Start Date</label>
                <input
                  type='date'
                  value={values?.firstBillDateStart}
                  max={values?.firstBillDateEnd}
                  onChange={(e) =>
                    setValues({ ...values, firstBillDateStart: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>End Date</label>
                <input
                  type='date'
                  value={values?.firstBillDateEnd}
                  min={values?.firstBillDateStart}
                  onChange={(e) =>
                    setValues({ ...values, firstBillDateEnd: e.target.value })
                  }
                />
              </div>
            </>
          </FilterModel>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default OverAllDataReport;
